import { api } from '@/lib/api';
import type { StudyPdfAnnotation, StudyPdfAnnotationInput } from './studyApi';

export const listImageAnnotations = (id: string, cursor?: string) =>
  api<{ items: StudyPdfAnnotation[]; next_cursor: string | null }>(
    `/study/documents/${encodeURIComponent(id)}/image-annotations?page_number=1${cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''}`,
  );
export const saveImageAnnotation = (id: string, input: StudyPdfAnnotationInput) =>
  api<StudyPdfAnnotation>(`/study/documents/${encodeURIComponent(id)}/image-annotations`, {
    method: 'POST',
    body: input,
  });
export const removeImageAnnotation = (id: string, item: StudyPdfAnnotation) =>
  api<{ id: string; status: 'deleted' }>(
    `/study/documents/${encodeURIComponent(id)}/image-annotations/${encodeURIComponent(item.id)}`,
    { method: 'DELETE', headers: { 'if-match': String(item.version) } },
  );
